import type { SanityHeaderFooterLayoutProps } from '../../../../js/layout/SanityHeaderFooterLayout';
import SanityHeaderFooterLayout from '../../../../js/layout/SanityHeaderFooterLayout';
import { AlphabetList } from '../../../../js/sanity/components/AlphabetList';
import Breadcrumbs from '../../../../js/sanity/components/Breadcrumbs';
import Header from '../../../../js/sanity/components/Header';
import type { DrinkRecipeProps } from '../../../../js/sanity/grid/DrinkRecipe';
import DrinkRecipe from '../../../../js/sanity/grid/DrinkRecipe';
import { FilterableGrid } from '../../../../js/sanity/grid/FilterableGrid';
import maybeSingleItemPage from '../../../../js/sanity/infrastructure/maybeSingleItemPage';
import SanityPage from '../../../../js/sanity/infrastructure/SanityPage';
import type { ListPageFor } from '../../../../js/sanity/page/ListPage/groq';
import * as DrinkRecipePage from './DrinkRecipes/[slug]';

export default SanityPage<ListPageFor<DrinkRecipeProps>>(({ page, url, breadcrumbs }) => (
    <article className="sanity" lang={page.metadata?.language}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Header title={page.title} ingress={page.ingress} />
        <AlphabetList list={page.list.map((i) => i.title)} />
        <FilterableGrid items={page.list} component={DrinkRecipe} gridMode="single-column" selectedTags={url.searchParams.getAll('tag')} />
    </article>
));

export function StaticLayout({ props, url }: SanityHeaderFooterLayoutProps<ListPageFor<DrinkRecipeProps>>) {
    return maybeSingleItemPage({ props, url }, DrinkRecipePage) ?? <SanityHeaderFooterLayout props={props} url={url} dynamic />;
}

// Force this file to be treated as a page
export const onRequest = () => null;
export const path = __FILE_PATH__;
